module.exports = __webpack_public_path__ + "static/media/Pic3.b50fe3a8.png";